var getSmallSize = '14px';

var getTitleSize = function getTitleSize(props) {
  switch (props.tag) {
    case 'h1':
      return '30px';

    case 'h2':
      return '28px';

    case 'h3':
      return '24px';

    case 'h4':
      return '22px';

    case 'h5':
      return '18px';

    case 'h6':
      return '16px';

    default:
      return '24px';
  }
};

export default {
  getTitleSize: getTitleSize,
  getSmallSize: getSmallSize
};